/* eslint-disable no-shadow */
import * as React from 'react';
import { getBreakpointByWidth, hasBreakpointChangedForProps, sortedBreakpointsKeys, } from './responsivePropReact';
/**
 * A custom React hook that causes your component to re-render if and only if the screen
 * is resized to such a degree that a different breakpoint is necessary.
 * @param responsiveProps List all responsive props of your component here. You need to list
 * them up because maybe not all of them will be configured with the same breakpoints by the user.
 * @returns the current breakpoint that entered last time we hit a breakpoint that a prop reacts to.
 */
export var useResize = function () {
    var _a;
    var responsiveProps = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responsiveProps[_i] = arguments[_i];
    }
    var _b = React.useState(document.documentElement.clientWidth), clientWidth = _b[0], setClientWidth = _b[1];
    React.useEffect(function () {
        var handleResize = function () {
            var newClientWidth = document.documentElement.clientWidth;
            if (!hasBreakpointChangedForProps(responsiveProps, newClientWidth, clientWidth))
                return;
            setClientWidth(newClientWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    });
    return (_a = getBreakpointByWidth(sortedBreakpointsKeys, clientWidth)) !== null && _a !== void 0 ? _a : 'xs';
};
//# sourceMappingURL=useResize.js.map